import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import { branch } from 'baobab-react/higher-order';
import FaqCategoryList from './FaqCategoryList';
import SupportNav from '../SupportNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';

class FaqLanding extends Component {
	componentDidMount() {

	}

	render() {
		const categories = this.props.faqs.categories;
		return (
			<div className="faqs">
				<Helmet>
					<title>Frequently Asked Questions | SentrySafe</title>
					<meta name="description" content="Find answers to the most frequently asked questions about SentrySafe products." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="FAQs" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Frequently Asked Questions"
					description="Find answers to the most frequently asked questions about SentrySafe products."
				/>

				<FaqCategoryList category={ categories } />
			</div>
		);
	}
};

export default branch({
	faqs: ['faqs']
}, FaqLanding);


// WEBPACK FOOTER //
// ./src/pages/support/faqs/Index.js